/*
 * @Description:布局设置有关
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */

import useViewFields from '@/hooks/view-fields';
import { reactive, toRefs } from 'vue';
import { fieldTypeObj } from '@/utils/const';
import i18n from '@/locales/index';
import { tools } from '@/utils/tools.js';
import { Message } from '@arco-design/web-vue';
import { setService } from '@/api/';
import useObjectForm from '@/hooks/object-form';

import { cloneDeep } from 'lodash';
// import { useGrayscaleStore } from '@/store';
export default function getLayoutFields() {
  const { getRecordType, setRecordLabel } = useObjectForm();
  const { enableList, getViewFields } = useViewFields();

  const data = reactive({
    treeData: [],
    newEnableList: [],
    layoutEnableList: [],
    originalModules: {
      //存储字段的信息
      modules: [],
      allModules: [] //所有字段
    },
    tabComponent: ['linkMan', 'schedule', 'invoice', 'address', 'cloud', 'priceInfo', 'approvalRecord', 'customerLinkMan'], //系统对象内置组件
    layoutTableBtnModules: {
      //关联对象表格按钮
      150: {
        //通用按钮
        modules: [],
        allModules: [],
        setChecked: []
      },
      160: {
        //批量按钮
        modules: [],
        allModules: [],
        setChecked: []
      },
      170: {
        //快捷按钮
        modules: [],
        allModules: [],
        setChecked: []
      },
      //tab页签里的按钮组('linkMan', 'schedule', 'invoice', 'address', 'cloud', 'priceInfo', 'approvalRecord', 'customerLinkMan')
      linkMan: {
        //联系人

        modules: [],
        allModules: [],
        setChecked: []
      },
      schedule: {
        //日程

        modules: [],
        allModules: [],
        setChecked: []
      },
      invoice: {
        //信息

        modules: [],
        allModules: [],
        setChecked: []
      },
      address: {
        //地址

        modules: [],
        allModules: [],
        setChecked: []
      },
      cloud: {
        //资料沉淀

        modules: [],
        allModules: [],
        setChecked: []
      },
      priceInfo: {
        //价格

        modules: [],
        allModules: [],
        setChecked: []
      },
      approvalRecord: {
        //审批

        modules: [],
        allModules: [],
        setChecked: []
      },
      customerLinkMan: {
        //客户关键联系人（售后服务对象中）

        modules: [],
        allModules: [],
        setChecked: []
      },
      0: {
        //第一层嵌套表格快捷按钮
        modules: [],
        allModules: [],
        setChecked: []
      },
      1: {
        //第二层嵌套表格快捷按钮
        modules: [],
        allModules: [],
        setChecked: []
      }
    },
    allBtnGroup: [], //所有的按钮组合
    tableLevelConfig: [], //180 多层级表格数据

    showBtnList: {
      //布局中应显示的按钮
      1: [':edit', ':transfer', ':return', ':delete', ':share', ':transform', ':copy'],
      2: [':edit', ':transfer', ':delete', ':share', ':copy'],
      3: [':edit', ':transfer', ':delete', ':share', ':copy'],
      4: [':edit', ':copy', ':delete'],
      6: [':edit', ':transfer', ':delete', ':share', ':copy'],
      8: [':edit', ':transfer', ':delete', ':share', ':copy'],
      10: [':edit', ':transfer', ':delete', ':share', ':copy'],
      12: [':edit', ':transfer', ':delete', ':share', ':copy'],
      13: [':edit', ':transfer', ':delete', ':share', ':copy'],
      101: [':edit', ':delete', ':receive', ':allocation', ':transfer'],
      200: [':edit', ':transfer', ':delete', ':copy', ':addRedReversal']
    },
    associationRecord: [], //关联记录
    queryRecord: [], //查询记录
    associationRecordCom: {
      label: i18n.global.t('关联记录'),
      level: 'parent',
      display: 1,
      fieldType: 30,
      layoutFieldType: 30,
      isOpen: false,
      children: [],
      comName: ''
    },
    queryRecordCom: {
      label: i18n.global.t('查询记录'),
      level: 'parent',
      display: 1,
      fieldType: 31,
      layoutFieldType: 31,
      isOpen: false,
      children: [],
      comName: ''
    }
  });
  // 获取字段数据的个数
  const getModulesLens = (modules) => {
    let modulesLens = 0;
    modules
      ?.filter((f) => f?.type != 40)
      ?.map((m) => {
        if (m?.fieldType == 27 || m?.type == 35 || (m?.modules?.length && m?.type != 40 && !getRecordType(m?.type))) {
          //子表单
          modulesLens += m?.modules?.length;
        } else {
          modulesLens++;
        }
      });
    return modulesLens;
  };
  // 重置数据
  const resetData = () => {
    data.treeData = [];
    data.associationRecordCom.isOpen = false;
    data.associationRecordCom.children = [];
    data.queryRecordCom.isOpen = false;
    data.queryRecordCom.children = [];
    data.newEnableList = [];
    data.layoutEnableList = [];
  };

  const filterTreeData = (treeData) => {
    return treeData?.map((item) => {
      if (item.fieldType == 4) {
        item.children = item.children.filter((child) => child.fieldKey !== 'esignCustomerType');
      }
      if (item.fieldType == 11) {
        item.children = item.children.filter((child) => child.fieldKey !== 'esignOfficeLink');
      }
      return item;
    });
  };
  const getEnabledEntityOptions = (records = []) => {
    return records
      .filter((record) => record?.isEnabled)
      .map((record) => ({
        label: record.entityName,
        value: String(record.entityType)
      }));
  };
  //请求字段列
  const getFields = async (params) => {
    // params.type//布局类型，类型不同，展示的可选字段页不同，params.type==1新增/编辑不展示系统字段.params.type==2 详情布局

    resetData();
    await getViewFields({ id: params.id, fieldName: params.fieldName });
    let getEnableList = JSON.parse(JSON.stringify(enableList.value));
    //id：对象（entity），type:来源。（2：详情，1：新建、编辑，3：导入）entityType：操作类型：20：详情，30：新增 40：编辑
    getEnableList = params.id == 3 && (params.type == 1 || params.type == 2) ? getEnableList?.filter((i) => i.fieldKey != 'personName' && i.fieldKey != 'mobile') : getEnableList;
    //商机对象详情，新增，编辑布局中隐藏联系人及联系方式
    data.layoutEnableList = params.type == 2 ? getEnableList : getEnableList?.filter((i) => i.fieldType != 13); //新增/编辑页面不需要展示编码类型
    if (params.type == 1 && params?.entityType == 40 && (params.id == 1 || params.id == 2)) {
      //销售线索，客户对象编辑布局时隐藏联系人及联系方式
      data.layoutEnableList = data.layoutEnableList?.filter((i) => i.fieldKey != 'personName' && i.fieldKey != 'mobile');
    }
    // 导入模板逻辑
    const filterConditions = {
      typeExclude: [13, 18, 21, 24, 25, 27], //非系统字段且启用的字段，不需要展示编码,附近，引用字段，计算类型,子表
      idSpecificFilters: {
        1: ['cluePoolId'], //线索过滤掉线索池字段
        101: ['followUser'] //线索池过滤掉最新跟进人字段
      }
    };

    if (params.type === 3) {
      data.layoutEnableList = getEnableList?.filter((i) => !filterConditions.typeExclude.includes(i.fieldType) && i.type !== 0).filter((i) => !filterConditions.idSpecificFilters[params.id]?.includes(i.fieldKey));
    }

    const newFieldList = data.layoutEnableList.reduce((acc, cur) => {
      if (!acc[cur.fieldType]) acc[cur.fieldType] = [];
      const _modules = [];
      cur.settingId = cur.id;
      cur.id = '';
      cur.level = 'children';
      cur.checked = false;
      cur.systemFieldtype = cur.type; //系统，基础，自定义
      cur.layoutFieldType = cur.fieldType == 27 ? 35 : 20; //布局类型字段
      cur.label = cur.fieldName;
      cur.value = cur.fieldKey;
      cur.isExistDefValue = 0; //0-不展示默认值 1-展示统一默认值
      cur.display = 1; //0-默认不可见，1-默认可见 2-满足条件可见
      cur.memo = ''; //附加说明
      cur.placeholder = cur.fieldType === 0 || cur.fieldType === 1 || cur.fieldType === 11 || cur.fieldType === 13 ? i18n.global.t('请输入') + cur.fieldName : i18n.global.t('请选择') + cur.fieldName;
      cur.displayOneLine = 0; //是否整行展示
      cur.isRequired = cur.isRequired ? 1 : 0; //0-非必填 1-必填 2-满足条件必填
      cur['isRequiredDefault'] = cur.isRequired ? true : false; //0-非必填 1-必填 2-满足条件必填
      cur.addIsRequired = cur.isRequired ? true : false;
      // cur.toast = cur.fieldKey === 'mobile' ? i18n.global.t('tips.defaultMobile') + i18n.global.t('tips.defaultMobileFixed') : ''; //提示
      cur.businessData = '1'; //编辑页--代表是否可编辑 0-不可编辑 1-可修改 2-满足条件编辑
      if (cur.fieldType == 27) {
        let parseJson = null;
        if (tools.isJSON(cur?.business)) {
          parseJson = JSON.parse(cur?.business);
          cur.businessData = parseJson?.businessData;
          cur.associateKey = parseJson?.associateKey;
        }
        cur.permission = 1;
        cur.permissionDetail = ['edit', 'remove', 'add', 'insert'];
        //子表单
        cur.settings.map((scm) => {
          if (scm.fieldKey != parseJson?.associateKey) {
            _modules.push({
              ...scm,
              settingId: scm.id,
              id: '',
              level: 'children',
              checked: false,
              systemFieldtype: scm.type,
              layoutFieldType: 20, //布局类型字段
              label: scm.fieldName,
              value: scm.fieldKey,
              fieldType: scm.fieldType,
              isExistDefValue: 0, //0-不展示默认值 1-展示统一默认值
              display: 1, //0-默认不可见，1-默认可见 2-满足条件可见
              memo: '', //附加说明
              placeholder: [0, 1, 11, 13].includes(scm.fieldType) ? i18n.global.t('请输入') + scm.fieldName : i18n.global.t('请选择') + scm.fieldName,
              displayOneLine: 0, //是否整行展示
              isRequired: scm.isRequired ? 1 : 0, //0-非必填 1-必填 2-满足条件必填
              isRequiredDefault: scm.isRequired ? true : false, //0-非必填 1-必填 2-满足条件必填
              addIsRequired: scm.isRequired ? true : false,
              toast: '', //提示
              businessData: '1', //编辑页--代表是否可编辑 0-不可编辑 1-可修改 2-满足条件编辑
              modules: [],
              conditions: null
            });
          }
        });
      }
      cur.modules = _modules;
      cur.conditions = null;
      if (params.type == 1) {
        if (cur.type && cur.type !== 0) {
          //不是系统字段
          acc[cur.fieldType].push(cur);
        }
      } else {
        acc[cur.fieldType].push(cur);
      }

      return acc;
    }, {});

    for (const i in newFieldList) {
      if (newFieldList[i].length > 0) {
        const newTreeData = { label: fieldTypeObj[i], fieldType: i, level: 'parent', isOpen: params.fieldName ? true : false, children: newFieldList[i], comName: '' };

        data.treeData.push(newTreeData);
      }
    }
    if (params.type == 1 || params.type == 2) {
      //查询，关联记录

      data.treeData.push(data.associationRecordCom, data.queryRecordCom);
      const component = {
        label: i18n.global.t('组件'),
        level: 'parent',
        display: 1,
        fieldType: 100,
        isOpen: params.fieldName ? true : false,
        children: [],
        comName: ''
      };
      if (params.type == 1) {
        //新增页面 --组件显示关联对象表格
        component.children = [{ label: i18n.global.t('关联记录'), level: 'children', display: 1, layoutFieldType: '30', isRequired: 0, version: 0 }];
        //新建/编辑页面需要默认展示必填字段
        data.newEnableList = data.layoutEnableList?.filter((el) => el.type && el.type !== 0 && el.isRequired);
        data.newEnableList.forEach((el) => {
          el.systemFieldtype = el.type; //系统，基础，自定义
          el.layoutFieldType = el?.fieldType == 27 ? 35 : 20; //字段标识
        });
        data.treeData = filterTreeData(data.treeData);
      }
      if (params.type == 2) {
        //详情页面 --组件显示关联对象表格，关联对象字段 (additionalBusiness:0 默认不开启多层级表格)
        component.children = [
          { label: i18n.global.t('查询记录'), level: 'children', display: 1, layoutFieldType: '31', isRequired: 0, additionalBusiness: '0', version: 0 },
          { label: i18n.global.t('外链容器'), level: 'children', display: 1, layoutFieldType: '60', height: 200, borderType: 'none' }
        ];
      }
      data.treeData.push(component);
    }
  };
  //组装获取记录的数据

  // 获取按钮组（type=150：通用按钮,type=170：快捷按钮,type=160：批量按钮）
  // 参数 btnGroup：所有按钮，btnModules：已选按钮，type：类型
  const getBtnGroup = (btnGroup, btnModules, type) => {
    console.log('btnGroup', btnModules, type);
    const getBtnModules = cloneDeep(btnModules);
    data.layoutTableBtnModules[type] = {
      //初始化数据
      modules: [],
      allModules: [],
      setChecked: []
    };
    data.layoutTableBtnModules[type].allModules = btnGroup;
    const getModulesMap = new Map();
    getBtnModules?.forEach((module) => {
      getModulesMap.set(module.value, module);
    });
    // 按 btnModules 顺序处理
    const processedKeys = new Set();
    getBtnModules?.forEach((module) => {
      const en = btnGroup?.find((item) => item.value == module.value);

      if (en) {
        processedKeys.add(en.value);
        data.layoutTableBtnModules[type].modules.push({
          ...en,
          showField: en.value == module?.value ? true : false
        });
        data.layoutTableBtnModules[type].setChecked.push(en.settingId);
      }
    });
    // 处理不在 btnModules 中的元素
    btnGroup?.forEach((en) => {
      if (!processedKeys.has(en.value)) {
        data.layoutTableBtnModules[type].modules.push({
          ...en,
          showField: false
        });
      }
    });
    // console.log('data.layoutTableBtnModules', data.layoutTableBtnModules);
  };
  //详情按钮过滤
  const filterLayoutBtn = (params) => {
    let _filterBtns = [];
    _filterBtns = params.btnGroup.filter((_fb) => {
      const _fbMark = _fb?.value?.split(':')?.[1] || '';
      if (params.entity >= 200) {
        return data.showBtnList?.[200]?.includes(`:${_fbMark}`);
      } else if (data.showBtnList?.[params.entity]?.length) {
        return data.showBtnList?.[params.entity]?.includes(`:${_fbMark}`);
      } else {
        return false;
      }
    });
    return _filterBtns;
  };
  // 获取按钮（通用，快捷，批量等）
  // 参数 20：详情，30,40：新建。编辑 10:列表布局，
  const getBtnCollection = async (params) => {
    console.log('按钮params', JSON.parse(JSON.stringify(params)));
    try {
      const setParams = {
        entity: params.entity,
        position: params?.position || '5'
      };
      const res = await setService.getBtnSetListByLayout(setParams);
      if (!res.error) {
        res?.result?.[0]?.values?.forEach((item) => {
          item.label = item.name;
          item.value = item.code;
          item.settingId = item.id;
          item.type = '40'; // 按钮类型固定
        });
        data.allBtnGroup = res.result;
        if (params?.source != 10) {
          //非列表布局
          const result = data.allBtnGroup[0]?.values;
          let filterBtns = result;
          if (params?.source == 20) {
            //详情
            filterBtns = filterLayoutBtn({ btnGroup: result, entity: params.entity });
          }
          getBtnGroup(filterBtns, params.buttonselectedList, params.type);
        }
      } else {
        Message.error(res.error?.msg || i18n.global.t('操作失败'));
        data.allBtnGroup = [];
        data.layoutTableBtnModules[params.type] = {
          //初始化数据
          modules: [],
          allModules: [],
          setChecked: []
        };
      }
    } catch (e) {
      console.log(e);
      data.allBtnGroup = [];
      data.layoutTableBtnModules[params.type] = {
        //初始化数据
        modules: [],
        allModules: [],
        setChecked: []
      };
    }
  };

  // 递归判断条件是否为空
  const isDeepEmptyCondition = (obj) => {
    if (obj.isGroup) {
      let result = null;
      for (let i = 0; i < obj.children.length; i++) {
        result = isDeepEmptyCondition(obj.children[i]);
        if (result === null) {
          return null;
        }
      }
      return obj;
    } else {
      if (obj.operation == 'null' || obj.operation === 'not_null' || obj.operation === 'equals_current_value') {
        if (!obj.field || !obj.operation) {
          return null;
        }
      } else if (!obj.field || (!obj.value && obj.value !== 0) || !obj.operation) {
        return null;
      }
      return obj;
    }
  };
  // 根据字段信息处理布局信息(field:字段信息，isSetting：是否有子级，parentItem：父级的字段 信息)
  const formatModules = (field, isSetting = false, parentItem) => {
    const business = {};
    if (field?.fieldType == 27) {
      let businessObj = {};
      if (tools.isJSON(field?.business)) {
        businessObj = JSON.parse(field?.business);
      }
      business['businessData'] = businessObj?.businessData || field?.businessData;
      business['associateKey'] = businessObj?.associateKey || field?.associateKey;
    }
    return {
      label: field.fieldName,
      value: field.fieldKey,
      fieldName: field.fieldName,
      id: field.id,
      parentId: field?.parentId,
      settingId: field.settingId,
      modules: (isSetting ? field?.settings : field?.modules)?.map((subItem) => formatModules(subItem, isSetting, field)) || [],
      fieldType: field.fieldType,
      fieldKey: field.fieldKey,
      fieldExt: field?.fieldExt ? field.fieldExt : '',
      isRequired: field.isRequired ? 1 : 0,
      mainField: field.mainField,
      type: field.fieldType == 27 ? '35' : '20', //子表单类型是35 字段是20
      isExpandShow: field.fieldType == 27 ? true : false, //默认都展开
      businessData: field.businessData, //置顶标识
      showField: field.showField, //是否显示的字段（true：是）
      entityType: parentItem ? parentItem?.fieldExt : '', //子表单的 entity
      ...business
    };
  };

  // 处理多层级表格数据
  const handleLevelTableModules = (getModules) => {
    //多层级表格设置
    const firstLevelModules = cloneDeep(getModules?.modules || []).filter((el) => el.type == 31);
    // 如果存在第一层模块，尝试找到第二层 type 为 31 的模块
    let secondLevelModule = null;
    if (firstLevelModules.length > 0) {
      const modulesOfFirst = cloneDeep(firstLevelModules[0].modules || []);
      secondLevelModule = modulesOfFirst.find((el) => el.type == 31);
      if (firstLevelModules[0]?.modules?.length > 0) {
        // 更新第一层模块，排除 type 为 31 的模块
        const updatedFirstLevelModules = cloneDeep(firstLevelModules[0]?.modules || []).filter((el) => el.type != 31);
        firstLevelModules[0].modules = updatedFirstLevelModules;
      }
    }

    // 将更新后的第一层模块与第二层模块合并
    data.tableLevelConfig = firstLevelModules && firstLevelModules?.length > 0 ? [...firstLevelModules] : [];
    if (secondLevelModule) {
      data.tableLevelConfig.push(secondLevelModule);
    }
    if (Array.isArray(data.tableLevelConfig)) {
      data.tableLevelConfig = data.tableLevelConfig.map((item) => ({
        ...item,
        showField: true,
        modules: item?.modules?.map((mo) => ({
          ...mo,
          showField: true
        }))
      }));
    }
  };
  // 根据字段信息处理modules信息 (field:字段信息，modules：布局信息)
  const processItem = (field, modules) => {
    if (field?.fieldType == 27) {
      // 子表单
      const subModules = [];
      const subModulesMap = new Map();
      modules?.modules?.forEach((subModule) => {
        subModulesMap.set(subModule.value, subModule);
      });

      // 按子表单模块顺序处理
      const subProcessedKeys = new Set();
      modules?.modules?.forEach((subModule) => {
        const subElm = field?.settings?.find((item) => item.fieldKey == subModule.value);
        if (subElm) {
          subProcessedKeys.add(subElm.fieldKey);
          subModules.push({
            ...subElm,
            businessData: '0',
            id: subModule.id,
            parentId: subModule?.parentId || '',
            settingId: subElm.id,
            showField: subModule.value === subElm.fieldKey ? true : false
          });
        }
      });

      // 处理不在子表单模块中的元素
      field?.settings?.forEach((subElm) => {
        if (!subProcessedKeys.has(subElm.fieldKey)) {
          const findSubField = subModulesMap.get(subElm.fieldKey);
          subModules.push({
            ...subElm,
            businessData: '0',
            id: subElm.id,
            parentId: subElm?.parentId || '',
            settingId: subElm.id,
            showField: findSubField?.value === subElm.fieldKey ? true : false
          });
        }
      });

      if (subModules.length > 0) {
        data.originalModules.modules.push(
          formatModules({
            ...field,
            businessData: '0',
            modules: subModules,
            id: modules?.id,
            parentId: modules?.parentId || '',
            settingId: field?.id,
            showField: field.fieldKey === modules?.value ? true : false
          })
        );
      }
    } else {
      data.originalModules.modules.push(
        formatModules({
          ...field,
          businessData: modules?.businessData || '0',
          id: modules?.id,
          parentId: modules?.parentId || '',
          settingId: field.id,
          showField: field.fieldKey === modules?.value ? true : false
        })
      );
    }
  };
  // 处理表格的数据
  const handleModules = async (allModules, fieldModules) => {
    data.originalModules = {
      //存储字段的信息
      modules: [],
      allModules: allModules //所有字段
    };
    const getModules = fieldModules;
    const getModulesMap = new Map();
    getModules?.forEach((module) => {
      getModulesMap.set(module.value, module);
    });
    const processedKeys = new Set();
    getModules?.forEach((module) => {
      const en = allModules?.find((item) => item.fieldKey == module.value);
      if (en) {
        processedKeys.add(en.fieldKey);
        processItem(en, module);
      }
    });
    allModules?.forEach((en) => {
      if (!processedKeys.has(en.fieldKey)) {
        const findModules = getModulesMap.get(en.fieldKey);
        processItem(en, findModules);
      }
    });
  };
  // 处理启用的字段
  const handleEnableFields = (enableFields) => {
    return enableFields?.map((el) => {
      return {
        ...el,
        settingId: el.id,
        value: el.fieldKey,
        label: el.fieldName,
        settings: el?.settings?.map((sub) => {
          //子表单
          return {
            ...sub,
            value: sub.fieldKey,
            label: sub.fieldName,
            settingId: sub.id
          };
        })
      };
    });
  };
  // 把字段处理成布局信息
  const handleFieldModules = (fieldList) => {
    return fieldList?.map((field) => {
      const business = {};
      if (field.fieldType == 27) {
        let businessObj = {};
        if (tools.isJSON(field?.business)) {
          businessObj = JSON.parse(field?.business);
        }
        business['businessData'] = businessObj?.businessData || field?.businessData;
        business['associateKey'] = businessObj?.associateKey || field?.associateKey;
      }
      return {
        fieldType: field?.fieldType,
        isRequired: field.isRequired ? 1 : 0,
        label: field.fieldName,
        value: field.fieldKey,
        type: field?.fieldType == 27 ? '35' : '20',
        modules: field.settings?.map((sub) => {
          return {
            fieldType: sub?.fieldType,
            isRequired: sub.isRequired ? 1 : 0,
            label: sub.fieldName,
            value: sub.fieldKey,
            type: '20'
          };
        }),
        ...business
      };
    });
  };

  // 处理关联记录，查询记录
  const getRecordList = (tabelModules) => {
    if (!tabelModules) return [];

    data.treeData?.forEach((item) => {
      tabelModules?.forEach((tabelModule) => {
        tabelModule?.children?.forEach((child) => {
          if (getRecordType(child?.type) && item?.layoutFieldType == child?.type && child?.version == 1) {
            item.children.push({ ...child, label: setRecordLabel(child), level: 'children' });
          }
        });
      });
    });
  };
  //搜索更新字段关联记录，查询记录，组件
  const searchRecordList = (copyTreeData, searchFieldName) => {
    if (!copyTreeData?.length || !searchFieldName) return [];
    const getCopyTreeData = cloneDeep(copyTreeData);
    // 将搜索关键词转为小写，统一比较基准
    const lowerSearchField = searchFieldName.toLowerCase();

    getCopyTreeData?.forEach((item) => {
      item.children =
        item.children?.filter((el) => {
          // 确保label存在，且转为小写后包含搜索关键词的小写形式
          return el?.label?.toLowerCase().includes(lowerSearchField);
        }) || [];
      item.isOpen = item.children?.length > 0;
    });

    return getCopyTreeData;
  };
  //清空modules里的id
  const clearModulesId = (modules) => {
    modules?.forEach((module) => {
      module.id = null;
      module.parentId = null;
      module.layoutId = null;
    });
    return modules;
  };
  const normalizeField = (field, modules = {}) => {
    return {
      ...field,
      settingId: field.id,
      id: '',
      level: 'children',
      checked: false,
      systemFieldtype: field.type,
      layoutFieldType: field.fieldType === 27 ? 35 : getRecordType(field.type) ? field.type : 20,
      label: field?.fieldName || field?.label,
      value: getRecordType(field.type) ? field.value : field.fieldKey,
      fieldType: getRecordType(field.type) ? field.type : field.fieldType,
      isExistDefValue: 0,
      display: 1,
      memo: '',
      placeholder: [0, 1, 11, 13].includes(field.fieldType) ? i18n.global.t('请输入') + field.fieldName : i18n.global.t('请选择') + getRecordType(field.type) ? field?.label : field?.fieldName || '',
      displayOneLine: null,
      isRequired: field.isRequired ? 1 : 0,
      isRequiredDefault: !!field.isRequired,
      addIsRequired: !!field.isRequired,
      businessData: field.businessData ?? '1',
      modules: [],
      conditions: null,
      ...modules
    };
  };
  // 获取表单设计的信息
  const getFormDesign = async (entity) => {
    const json = await setService.getFormDesignDetailV2({
      entity: entity
    });
    if (json.error && json.error?.msg) {
      Message.error(json.error?.msg || i18n.global.t('获取数据失败'));
      return [];
    }

    const fieldsResult = json?.result;
    const fieldModules = fieldsResult?.map((rItem) => ({
      label: rItem?.label,
      fieldType: null,
      level: 'parent',
      isOpen: false,
      children:
        rItem?.children?.map((cur) => {
          let modules = [];

          // 子表单（fieldType == 27）
          if (cur.fieldType === 27) {
            let parseJson = null;
            if (tools.isJSON(cur?.business)) {
              parseJson = JSON.parse(cur.business);
              cur.businessData = parseJson?.businessData;
              cur.associateKey = parseJson?.associateKey;
            }

            cur.permission = 1;
            cur.permissionDetail = ['edit', 'remove', 'add', 'insert'];

            modules =
              cur.settings
                ?.filter((scm) => scm.fieldKey !== parseJson?.associateKey)
                ?.map((scm) =>
                  normalizeField(scm, {
                    layoutFieldType: 20,
                    modules: [],
                    conditions: null
                  })
                ) || [];
          }
          if (getRecordType(cur.type)) {
            modules = cur?.modules || [];
          }

          return normalizeField(cur, { modules: clearModulesId(modules) });
        }) || []
    }));
    return fieldModules || [];
  };
  return {
    getFields,
    getRecordList,
    searchRecordList,
    getBtnGroup,
    getModulesLens,
    filterLayoutBtn,
    getBtnCollection,
    isDeepEmptyCondition,
    getEnabledEntityOptions,
    formatModules,
    handleLevelTableModules,
    handleModules,
    handleEnableFields,
    handleFieldModules,
    getFormDesign,
    ...toRefs(data)
  };
}
